const registration = {
  registration: {
    backButton: `Torna all'accesso`,
    pageHeader: 'Registrazione nuovo utente',
    installerNote: `Contattare l'amministratore della propria azienda/filiale per creare un ID utente e invitare l'utente`,
    registerOption:
      "Voglio registrare un'azienda che opera nel settore del solare con Enphase",
    installerOption: `Sono un installatore che lavora con un'azienda che ha già installato un sistema Enphase`,
    doItYourselfOption:
      'Sono un utente fai da te che installata prodotti Enphase',
    homeownerOption: 'Sono un proprietario di casa',
    updateSignuppage:
      'Acconsento ad essere contatto da Enphase tramite telefono o messaggio al numero inserito sopra per informazioni o aggiornamenti sul sistema oppure per messaggi di marketing correlati al mio sistema. Queste chiamate e questi messaggi di marketing possono essere inviati automaticamente o generati da una voce artificiale o pre-registrata. Il mio consenso a queste comunicazioni non è una condizione di acquisto e può essere revocato in qualunque momento e tramite qualsiasi mezzo ragionevole.',
    termsAndServices: `Ho letto l'%{privacyPolicy} di Enphase e ho letto e accetto le %{termsService}.`,
    termsServicesSafetyDisclaimer: `Confermo di aver letto e accettato l'%{safetyDisclaimer}, %{privacyPolicy} e le %{termsService}.`,
    safetyDisclaimer: 'Esclusione di responsabilità di sicurezza',
    accountHeader: 'I dettagli del tuo account',
    companyDetails: 'Dettagli azienda',
    firstName: 'Nome',
    lastName: 'Nome di battesimo',
    country: 'Nazione',
    email: 'E-mail',
    verificationHeader: 'Inserisci codice di verifica',
    verificationNote: `Inserire il codice di verifica di sei cifre inviato a %{email}`,
    didntReceivedOtp: `Non hai ricevuto il codice di verifica?`,
    resendOtp: 'Reinvia codice di verifica',
    setPasswordHeader: 'Imposta la password Enlighten',
    setPasswordNote:
      'Deve avere una lunghezza compresa tra 6 e 50 caratteri e contenere almeno 1 numero o carattere speciale',
    password: 'Password',
    confirmPassword: 'Conferma password',
    safetyDisclaimerNote: `L'installazione, la riparazione e la manutenzione dei prodotti Enphase devono essere eseguite solo da personale qualificato. I lavori elettrici devono essere eseguiti solo da elettricisti con licenza addestrati ad operare in conformità con il codice elettrico applicabile alla regione o al territorio, e informati sui requisiti legali e le considerazioni di sicurezza associati ai sistemi solari, di accumulo e di gestione energetica. Fare sempre riferimento ai manuali e alle guide di installazione.`,
    fieldRequired: 'Questo campo è obbligatorio.',
    validEmail: 'Inserire un indirizzo e-mail valido.',
    validPhone: 'Inserire un numero di telefono valido.',
    companyName: 'Nome azienda',
    streetAddress: 'Indirizzo',
    streetAddress2: 'Indirizzo 2',
    city: 'Città',
    state: 'Stato',
    zip: 'CAP/Codice postale',
    supportEmail: `E-mail dell'assistenza clienti`,
    supportPhone: `Telefono dell'assistenza clienti`,
    wesbiteUrl: 'URL sito Web',
    companyLogo: `Logo dell'azienda`,
    chooseFile: 'Scegli file',
    noFile: 'Nessun file selezionato',
    chooseFileNote: `Deve essere un file JPEG, GIF o PNG con dimensioni massime di 4MB. Per ottenere i migliori risultati, consigliamo un'immagine quadrata con sfondo trasparente larga almeno 400px e alta 400px.`,
    enphaseInstaller:
      'Questa azienda installa o prevede di installare sistemi Enphase',
    privacyPolicy: 'Informativa sulla privacy',
    termsService: 'Condizioni del servizio',
    andText: 'e',
    accountNote:
      'Nota: Tutti i sistemi aggiunti in questo account non verranno taggati su nessun installatore per la manutenzione',
    phone: 'Telefono',
    passwordMismatch:
      'Le password inserite nei campi precedenti devono essere identiche',
    updateSignupError:
      'Seleziona la casella sopra per procedere con la registrazione',
    privaryPolicyError:
      'Se non si accettano la Politica sulla privacy e i Termini del servizio di Enphase, non è possibile registrarsi a Enlighten.',
    otpSuccess: 'Codice di verifica reinviato correttamente',
    registrationSuccess:
      'Il tuo account Enlighten è stato creato correttamente',
    registrationSuccessRedirection:
      'Registrazione a Enlighten effettuata correttamente. Registrazione in corso...',
    login: 'Accedi',
    warningName: `Avvertenza: Nel sistema esiste già un'azienda con questo nome. Per essere sicuri di ottenere l'accesso corretto, contattare l'amministratore della propria azienda/filiale per chiedergli di creare un ID utente oppure contattare l'assistenza Enphase.`,
    errorName: `Nel sistema esiste già un'azienda con questo nome. Per essere sicuri di ottenere l'accesso corretto, contattare l'amministratore della propria azienda/filiale per chiedergli di creare un ID utente oppure contattare l'assistenza Enphase.`,
    warningAddress: `Avvertenza: Questo indirizzo è associato a un'azienda già esistente nel sistema. Per essere sicuri di ottenere l'accesso corretto, contattare l'amministratore della propria azienda/filiale per chiedergli di creare un ID utente oppure contattare l'assistenza Enphase.`,
    errorSupportEmail: `Questo ID e-mail è associato a un'azienda già esistente nel sistema. Per essere sicuri di ottenere l'accesso corretto, contattare l'amministratore della propria azienda/filiale per chiedergli di creare un ID utente oppure contattare l'assistenza Enphase.`,
    errorSupportPhone: `Questo numero di telefono è associato a un'azienda già esistente nel sistema. Per essere sicuri di ottenere l'accesso corretto, contattare l'amministratore della propria azienda/filiale per chiedergli di creare un ID utente oppure contattare l'assistenza Enphase.`,
    warningUrl: `Il link a questo sito Web è associato a un'azienda già esistente nel sistema. Per essere sicuri di ottenere l'accesso corretto, contattare l'amministratore della propria azienda/filiale per chiedergli di creare un ID utente oppure contattare l'assistenza Enphase.`,
    errorPhone: `Questo numero di telefono è già associato a un account esistente. Usare un numero di contatto diverso oppure contattare l'assistenza Enphase.`,
    errorEmail: `Questo indirizzo e-mail telefono è già associato a un account esistente. Usare un indirizzo e-mail diverso oppure contattare l'assistenza Enphase.`,
    streetNumberEmptyError:
      'Numero civico non trovato, verificare prima del salvataggio.',
    recaptchaError: 'Per procedere, completare la verifica reCAPTCHA.',
    infoText:
      'Assicurati che il marcatore sia collocato nella posizione esatta.',
    warningText:
      'Assicurati che il marcatore sia collocato nella posizione esatta.',
    locateMeText: 'Usa la funzione "localizzami" per ottenere la posizione.',
    addressCheckText: "Assicurati di aver inserito l'indirizzo corretto.",
    markerText: 'Posiziona il marcatore sulla posizione esatta.',
    mapErrorText: 'Scusa! Non siamo riusciti a localizzarti su Google Maps. ',
    validChamberNumber:
      'Inserimento non valido! Sono richiesti almeno 8 caratteri per il numero della Camera di Commercio',
    chamberofcommerce: 'Numero della Camera di Commercio'
  }
};

export default registration;
